import type { Locale } from "./catalogs.js";

const arabicIndicDigits = "٠١٢٣٤٥٦٧٨٩";
const easternArabicIndicDigits = "۰۱۲۳۴۵۶۷۸۹";

export function toWesternDigits(value: string): string {
  return Array.from(value)
    .map((character) => {
      const arabicIndex = arabicIndicDigits.indexOf(character);
      if (arabicIndex >= 0) return String(arabicIndex);
      const easternIndex = easternArabicIndicDigits.indexOf(character);
      return easternIndex >= 0 ? String(easternIndex) : character;
    })
    .join("");
}

export function formatDisplayDate(isoDate: string): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(isoDate);
  if (!match) throw new Error("Expected an ISO date in YYYY-MM-DD form");
  const [, year, month, day] = match;
  return `${day}/${month}/${year}`;
}

/**
 * Money, per the handoff spec: whole dirhams, dot thousands, unit after the
 * figure — "2.500 MAD" in French and logically "درهم 2.500" in Arabic so an
 * RTL container places the figure first from the right. Never decimals, never
 * Arabic-Indic digits.
 */
export function formatWholeFigure(value: bigint): string {
  const negative = value < 0n;
  const digits = (negative ? -value : value).toString();
  const grouped = digits.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return negative ? `−${grouped}` : grouped;
}

export function formatWholeMad(value: bigint, locale: Locale): string {
  const figure = formatWholeFigure(value);
  return locale === "ar" ? `درهم ${figure}` : `${figure} MAD`;
}
